export const NEWS_CATEGORY_TAGS = {
    NEWS_CATEGORIES: "GetNewsCategories",
} as const;